// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScoreBoard {
  position: absolute;
  background: #f9e5a9;
  z-index: 5;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 2px solid;
  border-top: none;
  transition: all 0.2s;
  min-width: 400px;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%); }
  .ScoreBoard:after {
    content: "^";
    position: absolute;
    left: 50%;
    transform: translate(-50%, -60%) rotate(180deg);
    width: 20px;
    display: flex;
    height: 20px;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    transition: all 0.2s;
    cursor: pointer; }
  .ScoreBoard.expanded {
    top: 0;
    left: 50%;
    transform: translateX(-50%); }
    .ScoreBoard.expanded:after {
      opacity: 0; }
  .ScoreBoard .score-wrapper {
    display: flex;
    justify-content: center;
    padding: 0 2rem 2rem; }
    .ScoreBoard .score-wrapper .TeamScore:last-of-type {
      margin-left: 5rem; }
`, "",{"version":3,"sources":["webpack://./src/components/ScoreBoard.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,mBCJkB;EDKlB,UAAU;EACV,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAEhB,MAAM;EACN,SAAS;EACT,iCAAiC,EAAA;EAbnC;IAgBI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,+CAA+C;IAC/C,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,eAAe,EAAA;EA3BnB;IA+BI,MAAM;IACN,SAAS;IACT,2BAA2B,EAAA;IAjC/B;MAoCM,UAAU,EAAA;EApChB;IAyCI,aAAa;IACb,uBAAuB;IACvB,oBAAoB,EAAA;IA3CxB;MA8CM,iBAAiB,EAAA","sourcesContent":["@import \"./../style/colors\";\n\n.ScoreBoard {\n  position: absolute;\n  background: $background;\n  z-index: 5;\n  border-bottom-right-radius: 10px;\n  border-bottom-left-radius: 10px;\n  border: 2px solid;\n  border-top: none;\n  transition: all 0.2s;\n  min-width: 400px;\n\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -100%);\n\n  &:after {\n    content: \"^\";\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -60%) rotate(180deg);\n    width: 20px;\n    display: flex;\n    height: 20px;\n    align-items: center;\n    justify-content: center;\n    font-size: 3rem;\n    transition: all 0.2s;\n    cursor: pointer;\n  }\n\n  &.expanded {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n\n    &:after {\n      opacity: 0;\n    }\n  }\n\n  .score-wrapper {\n    display: flex;\n    justify-content: center;\n    padding: 0 2rem 2rem;\n\n    .TeamScore:last-of-type {\n      margin-left: 5rem;\n    }\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
